<app-spinner></app-spinner>
<ng-container>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="wellBeingForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label for="first_name" class="text-black-1">Name/Question</label>
        </div>
        <div class="input-group col-8">
          <input
            id="name"
            class="form-control rb-input"
            placeholder="Please enter activity name."
            formControlName="name"
            name="name"
            type="text"
          />
          <!-- <div class="col-12 error-mssg" *ngIf="(f.name.touched || isFormSubmitted) && f.name.errors">
            <label for="name" class="text-danger" *ngIf="f.name.errors.required">*Name is required.</label>
          </div> -->
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Description</label>
        </div>
        <div class="input-group col-8">
          <textarea
            id="description"
            class="form-control rb-input"
            placeholder="Add activity description."
            formControlName="description"
            name="description"
            type="text"
          >
          </textarea>
          <div class="col-12 error-mssg" *ngIf="(f.description.touched || isFormSubmitted) && f.description.errors">
            <label for="description" class="text-danger" *ngIf="f.description.errors.required"
              >*Description is required.</label
            >
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="unit" class="text-black-1">Unit</label>
        </div>
        <div class="input-group col-8">
          <input
            id="unit"
            class="form-control rb-input"
            placeholder="Please enter the unit i.e s, kg, ml etc (If required)"
            formControlName="unit"
            name="unit"
            type="text"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Position</label>
        </div>
        <div class="input-group col-8">
          <input
            id="position"
            class="form-control rb-input"
            placeholder="Please enter the position of activity"
            formControlName="position"
            name="position"
            type="number"
          />
          <div class="col-12 error-mssg" *ngIf="(f.position.touched || isFormSubmitted) && f.position.errors">
            <label for="position" class="text-danger" *ngIf="f.position.errors.required"
              >*Please enter the position of the activity.</label
            >
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Question type</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="qtypeFields"
            optionLabel="viewValue"
            (onChange)="selectQuestionType($event)"
            formControlName="qtype"
            placeholder="Select question type."
          ></p-dropdown>
          <div class="col-12 error-mssg" *ngIf="(f.qtype.touched || isFormSubmitted) && f.qtype.errors">
            <label for="qtype" class="text-danger" *ngIf="f.qtype.errors.required">
              *Please select the question type.
            </label>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="selectedQuestionType === 'Scale'">
        <div class="col-4">
          <label for="lowerLabel" class="text-black-1">Lower label</label>
        </div>
        <div class="input-group col-8">
          <input
            id="lowerLabel"
            class="form-control rb-input"
            placeholder="Please enter the what lower point of scale represents."
            formControlName="lowerLabel"
            name="lowerLabel"
            type="text"
          />
          <div class="col-12 error-mssg" *ngIf="(f.lowerLabel.touched || isFormSubmitted) && f.lowerLabel.errors">
            <label for="lowerLabel" class="text-danger" *ngIf="f.lowerLabel.errors.required"
              >*Please enter the lower label of the scale.</label
            >
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="selectedQuestionType === 'Scale'">
        <div class="col-4">
          <label for="upperLabel" class="text-black-1">Upper label</label>
        </div>
        <div class="input-group col-8">
          <input
            id="upperLabel"
            class="form-control rb-input"
            placeholder="Please enter the what upper point of scale represents."
            formControlName="upperLabel"
            name="upperLabel"
            type="text"
          />
          <div class="col-12 error-mssg" *ngIf="(f.upperLabel.touched || isFormSubmitted) && f.upperLabel.errors">
            <label for="upperLabel" class="text-danger" *ngIf="f.upperLabel.errors.required"
              >*Please enter the upper label of the scale.</label
            >
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Min</label>
        </div>
        <div class="input-group col-8">
          <input
            id="min"
            class="form-control rb-input"
            placeholder="Please enter the minimum value."
            formControlName="min"
            name="min"
            type="number"
          />
          <div class="col-12 error-mssg" *ngIf="(f.min.touched || isFormSubmitted) && f.min.errors">
            <label for="min" class="text-danger" *ngIf="f.min.errors.required">*Please enter the min value.</label>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Max</label>
        </div>
        <div class="input-group col-8">
          <input
            id="max"
            class="form-control rb-input"
            placeholder="Please enter the maximum value"
            formControlName="max"
            name="max"
            type="number"
          />
          <div class="col-12 error-mssg" *ngIf="(f.max.touched || isFormSubmitted) && f.max.errors">
            <label for="max" class="text-danger" *ngIf="f.max.errors.required">*Please enter the max value.</label>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="selectedQuestionType === 'Scale' || selectedQuestionType === 'Counter'">
        <div class="col-4">
          <label for="description" class="text-black-1">Step</label>
        </div>
        <div class="input-group col-8">
          <input
            id="step"
            class="form-control rb-input"
            placeholder="Please enter the step between min and max value."
            formControlName="step"
            name="step"
            type="number"
          />
          <div class="col-12 error-mssg" *ngIf="(f.step.touched || isFormSubmitted) && f.step.errors">
            <label for="step" class="text-danger" *ngIf="f.step.errors.required">
              *Please enter the step between min and max value.
            </label>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Upload activity icon</label>
        </div>
        <div class="input-group col-8">
          <input type="file" (change)="onActivityUploadIcon($event)" accept="image/*" />
          <div class="activityImgPreview" *ngIf="preview && preview !== null">
            <img [src]="preview" [alt]="wellBeingForm.value.name" />
          </div>
          <div class="col-12 error-mssg" *ngIf="(f.img.touched || isFormSubmitted) && f.img.errors">
            <label for="img" class="text-danger" *ngIf="f.img.errors.required">
              *Please upload the image which can give visual reperesentation to your well being question/name.
            </label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="isActive" class="text-black-1" translate> Active status</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="status"
            optionLabel="name"
            optionValue="value"
            formControlName="isActive"
            placeholder="Select status"
          ></p-dropdown>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <span class="error-danger">
      *Inorder to maintain the consistency throughout the app. Please upload black/white image. You can download the
      image from <a href="https://www.flaticon.com/search?word=" target="_blank">this link.</a>
    </span>
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</ng-container>
